import { render, staticRenderFns } from "./PersonalDataPage.vue?vue&type=template&id=664bc56d&scoped=true"
import script from "./PersonalDataPage.vue?vue&type=script&lang=js"
export * from "./PersonalDataPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bc56d",
  null
  
)

export default component.exports